import { v4 as uuidv4 } from 'uuid';

export function addInInactiveSubscriptions({ subscription }) {
    subscription.isActive = false;
    subscription.failReasons = [{ reason: 'unsubscribe action requested', time: new Date().toISOString() }];
    this.inactiveSubscriptions.push(subscription);
    this.observed.subscriptions = uuidv4();
}
